import React from "react";
import { Dispatcher } from "../../Sites/SiteAboutPage/SiteAboutPageUtils/siteAboutInterfaces";
import {
  AlertData,
  MutedAlertSites,
  MutedAlertCameras,
} from "./alertsInterfaces";
import { handleAlertButtonsFill } from "./handleAlertButtonsFill";
import { NavigateFunction } from "react-router-dom";
import { getActiveIgnoreZones } from "./getActiveIgnoreZones";
import { checkForRedirectAndFetchMP4 } from "./checkForRedirectAndFetchMP4";
import { VlmFilterType } from "./vlmFilters";
import {
  arrowStateForNavigableIndex,
  filterAlertsBeforeVlm,
  getNavigableAlerts,
  isSameAlertRow,
  readStoredAlertsTableSort,
} from "./getNavigableAlerts";

export const handleForwardButtonClick = (
  selectedRow: any,
  setAlertIndex: Dispatcher<number>,
  setSelectedRow: any,
  alertData: any,
  navigate: NavigateFunction,
  setMP4URL: any,
  setVideoClipLoading: Dispatcher<boolean>,
  setSelectedButtonsFilled: any,
  setSeeMoreURL: Dispatcher<string>,
  setAlertData: any,
  setRefreshingData: Dispatcher<boolean>,
  setSelectedAlertCameraInfo: any,
  setIgnoreZonesSelectedAlert: any,
  alertsIndexOrder: any,
  detectionType: string,
  outcomeFilterType: string,
  setForwardArrowDisabled: Dispatcher<boolean>,
  setBackArrowDisabled: Dispatcher<boolean>,
  setShowRefreshButton: Dispatcher<boolean>,
  mutedAlertSites: MutedAlertSites,
  mutedAlertCameras: MutedAlertCameras,
  getCurrentSelectedRowKey?: () => string | null,
  setVideoProcessing?: Dispatcher<boolean>,
  useAsyncGeneration: boolean = true,
  setSelectedRowRef?: (row: any) => void,
  vlmFilterType: VlmFilterType = "All",
  filterType: string | null = "UNCLAIMED"
) => {
  const storedSort = readStoredAlertsTableSort();
  const listArgs = {
    alertData,
    detectionType,
    outcomeFilterType,
    mutedAlertSites,
    mutedAlertCameras,
    filterType,
    order: storedSort.order,
    orderBy: storedSort.orderBy,
  };
  const filteredBeforeVlm = filterAlertsBeforeVlm(listArgs);
  const filteredAlertData = getNavigableAlerts({
    ...listArgs,
    vlmFilterType,
    showVlmFilters: true,
    applyMuteFilter: true,
  });

  const currentIndex = filteredAlertData.findIndex((alert: any) =>
    isSameAlertRow(alert, selectedRow)
  );

  const hiddenByVlmFilter =
    currentIndex < 0 &&
    vlmFilterType !== "All" &&
    filteredAlertData.length > 0 &&
    filteredBeforeVlm.some((alert: any) => isSameAlertRow(alert, selectedRow));

  if (
    !hiddenByVlmFilter &&
    (!filteredAlertData || filteredAlertData.length <= 1 || currentIndex < 0)
  ) {
    setBackArrowDisabled(true);
    setForwardArrowDisabled(true);
    setRefreshingData(false);
    return;
  }

  const nextIndex = currentIndex + 1;
  if (nextIndex >= filteredAlertData.length) {
    const arrows = arrowStateForNavigableIndex(
      currentIndex,
      filteredAlertData.length
    );
    setForwardArrowDisabled(arrows.forwardDisabled);
    setBackArrowDisabled(arrows.backDisabled);
    setRefreshingData(false);
    return;
  }

  const nextArrows = arrowStateForNavigableIndex(
    nextIndex,
    filteredAlertData.length
  );
  setBackArrowDisabled(nextArrows.backDisabled);
  setForwardArrowDisabled(nextArrows.forwardDisabled);

  const newSelectedRow = filteredAlertData[currentIndex + 1];
  setSelectedRow(newSelectedRow);
  if (setSelectedRowRef) {
    setSelectedRowRef(newSelectedRow);
  }
  localStorage.setItem("selectedRowAlerts", JSON.stringify(newSelectedRow));
  getActiveIgnoreZones(
    newSelectedRow.camera_pk,
    setSelectedAlertCameraInfo,
    setIgnoreZonesSelectedAlert,
    navigate
  );
  checkForRedirectAndFetchMP4(
    newSelectedRow,
    navigate,
    setMP4URL,
    setVideoClipLoading,
    setShowRefreshButton,
    true,
    getCurrentSelectedRowKey,
    setVideoProcessing,
    useAsyncGeneration
  );
  handleAlertButtonsFill(newSelectedRow, setSelectedButtonsFilled);
  const newAlertData = alertData;
  const newSelectedRowIndex = alertData.findIndex((alert: any) =>
    isSameAlertRow(alert, newSelectedRow)
  );
  if (newSelectedRowIndex < 0) {
    setRefreshingData(false);
    return;
  }
  newAlertData.forEach((object: AlertData) => {
    object.selected = false;
  });
  newAlertData[newSelectedRowIndex].selected = true;
  setSeeMoreURL(newSelectedRow.alert_url);
  setAlertData(newAlertData);
  setRefreshingData(false);
};
